export function copyToClipboard(value: string){

    const dummyTextArea = document.createElement('textarea');
    document.body.appendChild(dummyTextArea);
    dummyTextArea.value = value;
    dummyTextArea.select();

    /* Although execCommand is deprecated, it has better browser support. */
    document.execCommand('copy');
    document.body.removeChild(dummyTextArea);

}

export function downloadBlob(blob: Blob, fileName: string){

    const url = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

}

/** Still needs to inject font-awesome stuff. A bit more difficult than it looks, apparently. --Jordan 06/28/22 */
export function printElement(element: HTMLElement){

    const newWindow = window.open('', '_blank');
    if (newWindow){

        document.head.childNodes.forEach(childNode => {

            const clonedNode = childNode.cloneNode(true);
            newWindow.document.head.appendChild(clonedNode);

        });
        newWindow.document.body.append(element.cloneNode(true));
        newWindow.print();

    }

}